export enum OpportunitiesFiltersTypes {

    Type = 'type',
    SolicitationNumber = "solicitationNumber",
    PostedDate = 'postedDate',
    ResponseDate = 'responseDate',
    Agency = 'agency',
    Keywords = 'keywords',
    PopState = 'popState',
    Naics = 'naics',
    PscCode = 'pscCode',
    SetAside = 'setAside'

}